import l10n from '../../lang/locallang';
import PopupClass from "./PopupClass";

const checkCoverImageIsExist = (parent = false) => {
    let covers;
    if (!parent) {
        covers = document.querySelectorAll('.course-tile_cover img');
    } else {
        covers = parent.querySelectorAll('.course-tile_cover img');
    }

    if (covers.length > 0) {
        covers.forEach((cover) => {
            // if image not loaded, add class no-image
            cover.addEventListener('error', () => {
                setTimeout(() => {
                    cover.closest('.course-tile_cover').classList.add('no-image');
                }, 100);
            });
        });
    }
}


// const stickyBarTable = () => {
//     const stickyBar = document.querySelector('.sticky-bar');
//     if (stickyBar) {
//         const stickyBarOffsetTop = stickyBar.getBoundingClientRect().top + window.pageYOffset - 43.2;
//         window.addEventListener('scroll', () => {
//             // if scroll more than breadcrumb offset top
//             if (window.pageYOffset > stickyBarOffsetTop) {
//                 stickyBar.classList.add('sticky');
//             }
//             if (window.pageYOffset < stickyBarOffsetTop) {
//                 stickyBar.classList.remove('sticky');
//             }
//         });
//     }
// }

const stickyBreadcrumb = () => {
    const breadcrumb = document.querySelector('.breadcrumbs-with-icons');
    if (breadcrumb) {
        const breadcrumbOffsetTop = breadcrumb.getBoundingClientRect().top + window.pageYOffset;
        window.addEventListener('scroll', () => {
            // if scroll more than breadcrumb offset top
            if (window.pageYOffset > breadcrumbOffsetTop) {
                breadcrumb.classList.add('sticky');
            }
            if (window.pageYOffset < breadcrumbOffsetTop) {
                breadcrumb.classList.remove('sticky');
            }
        });
    }
}

// function mobileNav() {
//     window.addEventListener('click', (e) => {
//         const button = e.target.closest('.hamburger');
//         if (button) {
//             button.classList.toggle('open');
//             document.querySelector('.header_nav').classList.toggle('show');
//         }
//     });
// }

// const priceSwitcher = () => {
//     const switchers = document.querySelectorAll('.prices-switcher');
//     for (let switcher of switchers) {
//         let switcherInput = switcher.querySelector('input');
//         let switcherBox = switcher.closest('.prices-box');
//         switcher.addEventListener('click', (e) => {
//             switcherInput.click();
//         });
//         switcherInput.addEventListener('change', () => {
//             if (switcherInput.checked) {
//                 // annual
//                 if (switcherBox.classList.contains('monthly')) {
//                     switcherBox.classList.remove('monthly');
//                 }
//                 switcherBox.classList.add('annual');
//             } else {
//                 // monthly
//                 if (switcherBox.classList.contains('annual')) {
//                     switcherBox.classList.remove('annual');
//                 }
//                 switcherBox.classList.add('monthly');
//             }
//             updatePrice(switcherBox);
//             setActivePlan(switcherBox);
//             changeHSLinks(switcherBox);
//         });
//
//         setActivePlan(switcherBox);
//         updatePrice(switcherBox);
//     }
//
//     function updatePrice(switcherBox) {
//         const { billedAnnually, billedMonthly } = l10n.pricePage;
//         const prices = switcherBox.querySelectorAll('.js-item-price');
//
//         for (let price of prices) {
//             const { monthly, annual} = price.dataset;
//             const priceValueMonthly = '$' + monthly;
//             const priceValueAnnual = '$' + annual;
//             const isAnnual = switcherBox.classList.contains('annual');
//             const priceText = price.querySelector('.js-item-sum');
//             const priceType = price.querySelector('.js-item-type');
//
//             if (priceText && priceType) {
//                 priceText.textContent = isAnnual ? priceValueAnnual : priceValueMonthly;
//                 priceType.innerText = isAnnual ? billedAnnually : billedMonthly;
//             }
//         }
//     }
//
//     function setActivePlan(switcherBox) {
//         const activeItem = document.querySelector('[data-active-plan]');
//
//         if (activeItem) {
//             const activePlanType = activeItem.dataset.activePlan;
//             const switcherBoxPlanTypeMatchActivePlanType = switcherBox.classList.contains(activePlanType);
//             activeItem.classList[switcherBoxPlanTypeMatchActivePlanType ? 'add' : 'remove']('is-active');
//         }
//     }
//
//     function changeHSLinks(switcherBox) {
//         const buttons = document.querySelectorAll('.js-item-link');
//         const isAnnualPrices = switcherBox.classList.contains('annual');
//
//         if (buttons) {
//             buttons.forEach(btn => {
//                 const { annualLink, monthlyLink } = btn.dataset;
//                 btn.href = `${isAnnualPrices ? annualLink : monthlyLink}`;
//             });
//         }
//     }
// }

const progressBar = () => {
    let bars = document.getElementsByClassName('progress-bar');
    if (bars.length > 0) {
        for (let bar of bars) {
            let progress = bar.querySelector('.progress-bar_value').dataset.progress;
            let background = bar.querySelector('.progress-bar_value').style.background;
            bar.querySelector('.progress-bar_value').style.cssText = 'width: ' + progress + '%; background-color: ' + background;
        }
    }
}

const collapseCompletedModule = () => {
    window.addEventListener('click', (e) => {
        let module = e.target.closest('.collapse-table');
        if (module) {
            if (module.classList.contains('collapsed')) {
                module.classList.remove('collapsed');
            } else {
                module.classList.add('collapsed');
            }
        }
    });
}


// const cardNumberInput = () => {
//     const cardNumberInput = document.getElementById('cardNumber');
//     if (!cardNumberInput) return;
//     cardNumberInput.addEventListener('input', function () {
//         let cardNumber = this.value.replace(/\s/g, ''); // Remove any existing spaces
//         cardNumber = cardNumber.replace(/\D/g, ''); // Remove non-numeric characters
//         cardNumber = cardNumber.slice(0, 16); // Limit to 16 digits
//         cardNumber = cardNumber.replace(/(\d{4})(?=\d)/g, '$1 '); // Add spaces every four digits
//
//         this.value = cardNumber;
//     });
// }

// const redirectToSignup = () => {
//     let links = document.querySelectorAll('.to-signup__js');
//
//     // Add click event listener to each link
//     links.forEach(function(link) {
//         link.addEventListener('click', function(event) {
//             // Prevent the default link behavior
//             event.preventDefault();
//
//             // Get the current page title, transform it to lowercase and replace spaces with underscores
//             let pageTitle = document.title.toLowerCase().replace(/\s/g, '_');
//
//             // Get the original href of the link
//             let originalHref = this.getAttribute('href');
//
//             // Append the page title as a query parameter
//             let newHref = originalHref + (originalHref.includes('?') ? '&' : '?') + 'page=' + pageTitle;
//
//             // Redirect to the new URL
//             window.location.href = newHref;
//         });
//     });
// }

const closeSigninPopup = () => {
    // on click to .js-login-close button, if in url history previous page was in same domain - redirect to this page
    const closeLoginPage = document.querySelector('.js-login-close');
    if (closeLoginPage) {
        closeLoginPage.addEventListener('click', () => {
            // if previous page was in same domain, but not /login and not /sign-up - redirect to previous page, else redirect to home page
            if (document.referrer.includes(window.location.origin) && !document.referrer.includes('/login') && !document.referrer.includes('/sign-up')) {
                window.history.back();
            } else {
                window.location.href = window.location.origin;
            }
        });
    }
}

// const sidebarSubmenu = () => {
//     let sidebar_nav = document.querySelector('.sidebar-menu');
//     if (sidebar_nav != null) {
//         let submenu = sidebar_nav.querySelectorAll('ul:not(.sidebar-menu_child) > li');
//         if (submenu.length) {
//             for (let i = 0, len = submenu.length; i < len; i++) {
//                 submenu[i].querySelector('a').addEventListener('click', function (e) {
//
//                     if (submenu[i].classList.contains('has-sub-menu')) {
//                         // Case if li has submenu
//
//                         // Switch open menu
//                         if (document.querySelector('.sidebar-menu').querySelector('.open')) {
//                             if (!submenu[i].classList.contains('open')) {
//                                 document.querySelector('.open').classList.remove('open');
//                                 submenu[i].classList.add('open');
//                             } else {
//                                 submenu[i].classList.remove('open');
//                             }
//                         } else {
//                             submenu[i].classList.add('open');
//                         }
//                     } else {
//
//                         // Case if li haven't submenu
//                         if (document.querySelector('.sidebar-menu').querySelector('.open')) {
//                             document.querySelector('.open').classList.remove('open');
//                         }
//                     }
//
//                 });
//             }
//         }
//     }
// }

// const getQuoteButton = () => {
//     const getQuoteButton = document.querySelectorAll('.btn-quote');
//     if (getQuoteButton) {
//         getQuoteButton.forEach((button) => {
//             button.addEventListener('click', (e) => {
//                 e.preventDefault();
//                 let form = document.querySelector('#get-quote');
//                 if (form) {
//                     let price_element = button.closest('.price-item').querySelector('.price-item_title h2').innerText;
//                     let price_users = button.closest('.price-item').querySelector('.users-limit').innerText;
//                     let price_period = button.closest('.prices-box').classList.contains('annual') ? 'annual' : 'monthly';
//                     form.querySelector('input[name="price-name"]').value = price_element;
//                     form.querySelector('input[name="price-users"]').value = price_users;
//                     form.querySelector('input[name="price-period"]').value = price_period;
//                 }
//             });
//         });
//     }
// }

// Open demo video on click to "Learn More" btn
// const learnMoreBtnHandler = () => {
//     const learnMoreBtn = document.querySelector('.js-open-demo');
//     const demoPopup = document.getElementById('demo-video');
//     const popupClassInit = new PopupClass();
//
//     if (learnMoreBtn && demoPopup) {
//         learnMoreBtn.addEventListener('click', () => {
//             const iframe = demoPopup.querySelector('iframe');
//
//             iframe.src = `/demo/intro_web/index.html`;
//             popupClassInit.open('demo-video');
//         });
//     }
// };

export {
    checkCoverImageIsExist,
    // stickyBarTable,
    stickyBreadcrumb,
    // mobileNav,
    // priceSwitcher,
    // cardNumberInput,
    progressBar,
    collapseCompletedModule,
    // redirectToSignup,
    closeSigninPopup,
    // sidebarSubmenu,
    // getQuoteButton,
    // learnMoreBtnHandler
}
